import SwaggerClient from '@/services/SwaggerClient';

export default class SwaggerDataProvider extends SwaggerClient {
    public async findAll(query: any = {}) {
        const findAllOptions = this.options.findAll
        const requestPayload = {
            "offset": query.offset,
            "limit": query.limit,
            "orders": query.orders,
            "search": query.search,
            "filters": query.filters,
            "extra_params": query.extra_params
        }
        const parameters: any = {
            "request_payload": JSON.stringify(requestPayload)
        }

        if (findAllOptions.paramFilter) {
            parameters.value = findAllOptions.paramFilter
        }
        const { body } = await this.execute(findAllOptions.operationId, parameters)
        let data = body.data

        if (findAllOptions.callback) {
            data = findAllOptions.callback(data)
        }

        return [data, Number(body.count)]
    }

    public async getById(query: any = {}) {
        const getByIdOptions = this.options.getById

        const { body } = await this.execute(getByIdOptions.operationId, {
            "value": query.value
        })
        return body.data
    }

    public async getElements(item) {
        const getByIdOption = this.options.getElements
        const { body } = await this.execute(getByIdOption.operationId, {
            "value": item[getByIdOption.key]
        })
        return body.data
    }
}
